module.exports = __webpack_public_path__ + "placeholder.png";